export default __webpack_public_path__ + "static/media/lock2.36d3ee26.svg";